import React from 'react';
import {
  FDSecondaryActionButton,
  FDStack, FDTextButton,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';

const FeedbackSelect = ({
  onBlur,
  onFocus,
  onChange,
}) => {
  return (
    <FDStack spacing={2} justifyContent={'center'}>
      <FDSecondaryActionButton
        label={'Continue'}
        onClick={() => {
          onChange('neutral');
        }}
        onBlur={onBlur}
        onFocus={onFocus}
        icon={'keyboardArrowRight'}
        iconPosition={'end'}
      />
      <div style={{
        position: 'absolute',
        transform: 'translateY(100px)',
      }}
      >
        <FDTextButton
          variant={'text'}
          color={'white'}
          onClick={() => onChange('negative')}
          onBlur={onBlur}
          onFocus={onFocus}
          label={"I don't agree with this"}
        />
      </div>
    </FDStack>
  );
};

FeedbackSelect.propTypes = {
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export { FeedbackSelect };
